import { render } from "./SideMenu.vue?vue&type=template&id=7516a4b6&scoped=true"
import script from "./SideMenu.vue?vue&type=script&lang=js"
export * from "./SideMenu.vue?vue&type=script&lang=js"

import "./SideMenu.vue?vue&type=style&index=0&id=7516a4b6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7516a4b6"
/* hot reload */
if (module.hot) {
  script.__hmrId = "7516a4b6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7516a4b6', script)) {
    api.reload('7516a4b6', script)
  }
  
  module.hot.accept("./SideMenu.vue?vue&type=template&id=7516a4b6&scoped=true", () => {
    api.rerender('7516a4b6', render)
  })

}

script.__file = "src/views/services/modules/internet/SideMenu.vue"

export default script